define('modules/page_listing/collections/pages',['require','exports','module','base/collection','../models/page','env'],function (require, exports, module) {
  var BaseCollection = require('base/collection'),
    Page = require('../models/page'),
    config = require('env');

  module.exports = BaseCollection.extend({
    model: Page,

    initialize: function (options) {
      this.querystring = options.querystring;
      this.paginationIsNeeded =
        options.paginationIsNeeded !== undefined ? options.paginationIsNeeded : true;
      if (this.paginationIsNeeded) {
        this.listenTo(this, 'sync', this.onSync);
        this.page = options.page || 1;
        this.pageSize = options.pageSize !== undefined ? options.pageSize : 10;
        this.sortBy = 'updated_at';
        this.hidden = false;
        this.published = 'all';
        this.totalItemCount = 0;
        this.pageCount = 0;
        this.loaded = false;
      }
    },

    url: function () {
      if (!this.paginationIsNeeded) return config.apiHost + '/pages?list=true';
      var hidden = this.hidden ? '&hidden' : '';
      var published = '&published=' + this.published;

      return (
        config.apiHost +
        '/pages' +
        '?page=' +
        this.page +
        '&items=' +
        this.pageSize +
        '&sortBy=' +
        this.sortBy +
        hidden +
        published
      );
    },

    onSync: function (collection, response, options) {
      this.collection = collection;
      this.loaded = true;
      this.totalItemCount = parseInt(options.xhr.getResponseHeader('X-TotalItemCount') || 0);

      this.pageCount = Math.ceil(this.totalItemCount / this.pageSize);
      this.querystring.set({ totalItemCount: this.totalItemCount });
    },

    fetchForSort: function (options, sortBy) {
      options = _.extend({}, options);
      this.page = 1;
      this.loaded = false;
      this.sortBy = sortBy;

      this.fetch(options);
    },

    fetchForHidden: function (options, hidden) {
      options = _.extend({}, options);
      this.page = 1;
      this.loaded = false;
      this.hidden = hidden;

      this.fetch(options);
    },
    fetchForPublished: function (options, published) {
      options = _.extend({}, options);
      this.page = 1;
      this.loaded = false;
      this.published = published;

      this.fetch(options);
    },

    fetchNextPage: function (options) {
      options = _.extend({ remove: false }, options);
      if (this.page < this.pageCount) {
        this.page++;
        this.loaded = false;
        this.fetch(options);
      } else {
        options &&
          options.callback &&
          options.callback(this.totalItemCount, this.collection.length);
      }
    },

    createCopyUrlFor: function (page, options) {
      var baseUrl = page.url(),
        querystring = $.param(options);
      return [baseUrl, 'copy'].join('/') + '?' + querystring;
    },

    duplicatePage: function (page, options, callback) {
      var newPage = page.clone();
      newPage.set('id', undefined);
      //remove stats
      newPage.unset('stats');
      newPage.url = this.createCopyUrlFor(page, options);
      newPage.once(
        'sync',
        function () {
          delete newPage.url;
          this.fetch({ reset: true });
          if (callback) {
            callback();
          }
        },
        this
      );
      newPage.save();
    },

    fetch: function (options) {
      options = _.extend(
        {
          data: this.querystring !== undefined ? this.querystring.toAttributesMap() : {},
        },
        options
      );
      return module.exports.__super__.fetch.call(this, options);
    },
  });
});

